export interface SupportMailRequest {
  readonly subject: string;
  readonly body: string;
  readonly logContent: string;
  readonly logFileName: string;
}

export interface SupportShareProvider {
  share(req: SupportMailRequest): void;
}

export const NOOP_SUPPORT_SHARE: SupportShareProvider = {
  share: () => {
    /* noop */
  },
};
